import { ModalityType } from '@asktia/tia-fhir-questionnaire/dist/src/validators/QuestionnaireResponse'
import {
    Box,
    Button,
    Container,
    Heading,
    LayoutGrid,
    Spinner,
    Text
} from '@asktia/tia-ui'
import { FC } from 'react'
import { NavBarHeading } from 'src/components/Blocks/NavBarHeading'
import { useCommunicationRequest } from 'src/flows/questionnaires/hooks/open-loop/useCommunicationRequest'
import { useServiceLine } from 'src/flows/questionnaires/hooks/open-loop/useServiceLine'

const getOutcomeContent = (
    modality: ModalityType,
    refillApptBookingUrl?: string
) => {
    switch (modality) {
        case 'DQ':
            return {
                title: 'Sorry, no longer a good fit',
                message:
                    'Based on your current health situation, this medication is no longer a good fit for you. Your Care Team will be reaching out to follow up with you promptly with next steps.'
            }
        case 'ITER_HOLD':
            return {
                title: "You're not yet ready for a refill",
                message:
                    'Please resubmit this intake form after having taken 3 or more weeks of your current medication'
            }
        case 'SYNC':
            return {
                title: 'Please schedule an appointment',
                message:
                    'Your care team would like to discuss your current health situation in more detail to assess next steps. Please proceed to the next page to schedule an appointment with an Open Loop provider to not cause any delays in your care',
                button: {
                    text: 'Book Now',
                    onClick: () => {
                        if (refillApptBookingUrl) {
                            window.location.href = refillApptBookingUrl
                        }
                    }
                }
            }
        case 'ASYNC':
            return {
                title: 'Review in Progress',
                message:
                    'Thank you for sharing about your current health situation. Your responses will be reviewed by the Open Loop care team and they will be getting in touch shortly with details about your refill.'
            }
        default:
            return {
                title: 'Error',
                message:
                    'An unexpected error occurred. Please try again or contact support.'
            }
    }
}
export const OLGLP1RefillOutcome: FC = () => {
    const { isLoading, isFetching, communicationRequest } =
        useCommunicationRequest()
    const { serviceLine, isLoading: isServLineLoading } = useServiceLine('mwl')

    if (isServLineLoading || isLoading || isFetching) {
        return (
            <>
                <NavBarHeading href="/your-care">Next Steps</NavBarHeading>
                <Container>
                    <LayoutGrid columns="one">
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                py: 8
                            }}
                        >
                            <Spinner />
                        </Box>
                    </LayoutGrid>
                </Container>
            </>
        )
    }

    const outcome = communicationRequest?.statusReason?.coding?.[0]
        ?.code as ModalityType

    const { title, message, button } = getOutcomeContent(
        outcome,
        serviceLine?.refillApptBookingUrl
    )

    return (
        <>
            <NavBarHeading href="/your-care">Next Steps</NavBarHeading>
            <Container>
                <LayoutGrid columns="one">
                    <Box sx={{ py: 6 }}>
                        <Heading h1 sx={{ mb: 4, textAlign: 'center' }}>
                            {title}
                        </Heading>
                        <Text
                            sx={{
                                fontSize: 3,
                                lineHeight: '24px',
                                textAlign: 'center',
                                maxWidth: '600px',
                                mx: 'auto',
                                mb: button ? 4 : 0
                            }}
                        >
                            {message}
                        </Text>
                        {button && (
                            <Box sx={{ textAlign: 'center', mt: 4 }}>
                                <Button onClick={button.onClick} fullWidth>
                                    {button.text}
                                </Button>
                            </Box>
                        )}
                    </Box>
                </LayoutGrid>
            </Container>
        </>
    )
}
